/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

export const useCurrentRouteSupportsProjectTheme: (
	// oxlint-disable-next-line typescript/no-invalid-void-type
	args_0: void,
) => 'full' | 'contoured' | undefined = createRouterSelector(
	(state) => state.route.supportsProjectTheme,
);

type ProjectTheme = {
	isInset: boolean;
	hasTheming: boolean;
};

export const useProjectTheme = (): ProjectTheme => {
	const supportsProjectTheme = useCurrentRouteSupportsProjectTheme();
	const hasTheming = Boolean(supportsProjectTheme);

	return {
		isInset: supportsProjectTheme === 'contoured',
		hasTheming,
	};
};
